import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinerOriginServiceFormComponent } from './liner-origin-service-form/liner-origin-service-form.component';
import { LinerOriginServiceListComponent } from './liner-origin-service-list/liner-origin-service-list.component';
import { LinerOriginServiceRoutingModule } from './liner-origin-service-routing.module';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    LinerOriginServiceFormComponent,
    LinerOriginServiceListComponent
  ],
  imports: [
    CommonModule,
    LinerOriginServiceRoutingModule,
    AngularMaterialModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule
  ]
})
export class LinerOriginServiceModule { }
